export default {
  entrance:
    "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/map/cave-entrance.png",
  caves: {
    1: {
      caveOneFrontCorridor: [
        null,
        null,
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/equip/helmet.png",
        null
      ],
      caveOneFrontRoom: [
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/map/cauldron.png",
        null
      ],
      caveOneBackCorridor: [
        null,
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/items/square-bottle.png",
        null,
        null
      ],
      caveOneBackRoom: [
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/equip/gloves.png",
        null,
        null
      ]
    },
    2: {
      caveTwoFrontCorridor: [
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/items/square-bottle.png",
        null,
        null,
        null
      ],
      caveTwoFrontRoom: [
        null,
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/equip/legs.png"
      ],
      caveTwoBackCorridor: [
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/items/potion-ball.png",
        null,
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/equip/mace.png",
        null
      ],
      caveTwoBackRoom: [
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/map/cauldron.png",
        null
      ]
    },
    3: {
      caveThreeFrontCorridor: [
        null,
        null,
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/items/potion-ball.png",
        null
      ],
      caveThreeFrontRoom: [
        null,
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/equip/shield.png"
      ],
      caveThreeBackRoom: [
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/equip/sword.png",
        null,
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/equip/breastplate.png",
        null
      ]
    },
    hidden: {
      hiddenPassage: [
        null,
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/equip/amulet.png",
        null,
        null
      ],
      smokyPassage: [
        null,
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/equip/axe.png",
        null,
        null,
        null,
        null,
        null,
        "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/items/potion-ball.png"
      ]
    }
  }
};
